import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { QuantumDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-quantum-container',
  templateUrl: './quantum-container.component.html',
  styleUrls: ['./quantum-container.component.scss'],
})
export class QuantumContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  quantums$: Observable<QuantumDto[]>;
  loading: boolean;
  isLoadingQuantum$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingQuantum$ = this.gatwayFacade.isLoadingGateway(
      'QuantumOfImpact'
    );
    this.quantums$ = this.gatwayFacade.loadGateway('QuantumOfImpact');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteQuantum(deletedValue: any) {
    this.gatwayFacade.remove('QuantumOfImpact', deletedValue);
  }

  // this method control both the create and update

  onSubmitQuantum(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Quantums;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllQuantum = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllQuantum.push(pullData[i]);
      }
    }

    // check if the addAllQuantum array is not empty, then dispatch the data to the store
    if (addAllQuantum.length > 0) {
      this.gatwayFacade.add('QuantumOfImpact', addAllQuantum);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('QuantumOfImpact', allUpdates, ['id']);
    }
  }
}
